export default "__VITE_ASSET__DihUIhTZ__"